/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Dok_S1Inputs */

const en_tut_dok_s1 = /** @type {(inputs: Tut_Dok_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open **Dokumen**, pick a template (**Kosong**, **Laporan**, **Proposal**, **Notulen rapat**, **Anggaran**, **Presentasi**) or press **Buat dokumen**.`)
};

const id_tut_dok_s1 = /** @type {(inputs: Tut_Dok_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka **Dokumen**, pilih template (**Kosong**, **Laporan**, **Proposal**, **Notulen rapat**, **Anggaran**, **Presentasi**) atau tekan **Buat dokumen**.`)
};

/**
* | output |
* | --- |
* | "Open **Dokumen**, pick a template (**Kosong**, **Laporan**, **Proposal**, **Notulen rapat**, **Anggaran**, **Presentasi**) or press **Buat dokumen**." |
*
* @param {Tut_Dok_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_dok_s1 = /** @type {((inputs?: Tut_Dok_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Dok_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_dok_s1(inputs)
	return en_tut_dok_s1(inputs)
});